import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { track } from "@/lib/analytics";

export default function BookCard({ book }) {
  const hasCover = !!book.cover_url;
  const onClick = () => track("book_click", { slug: book.slug, title: book.title });
  return (
    <div className="dl-book group" data-testid={`book-card-${book.slug}`}>
      <Link to={`/livres/${book.slug}`} onClick={onClick} className="block">
        <div className="dl-book-cover relative aspect-[2/3] bg-[#0B1020] border border-[rgba(198,167,106,0.25)] overflow-hidden">
          {hasCover ? (
            <img src={book.cover_url} loading="lazy" alt={`Couverture — ${book.title}`} className="w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center p-6 text-center"
              style={{ background: "linear-gradient(160deg, #141A2E 0%, #0B1020 100%)" }}>
              <BookOpen size={30} className="text-[#C6A76A]/60 mb-4" />
              <span className="serif text-xl text-[#F3E9D2] leading-tight">{book.title}</span>
              <span className="dl-eyebrow mt-4" style={{ fontSize: "0.55rem" }}>Dorothée Lancelot</span>
            </div>
          )}
          {book.is_new && (
            <span className="absolute top-3 right-3 bg-[#C6A76A] text-[#050814] text-[0.6rem] tracking-widest uppercase font-bold px-2.5 py-1">
              Nouveauté
            </span>
          )}
        </div>
      </Link>
      <div className="mt-5">
        {book.genre && <div className="dl-eyebrow mb-2" style={{ fontSize: "0.6rem" }}>{book.genre}</div>}
        <Link to={`/livres/${book.slug}`}>
          <h3 className="serif text-xl text-[#F3E9D2] leading-tight hover:text-[#D4B978] transition-colors">{book.title}</h3>
        </Link>
        {book.summary_short && <p className="text-sm text-[#F3E9D2]/60 mt-2 line-clamp-3">{book.summary_short}</p>}
        <div className="flex items-center gap-4 mt-4">
          <Link to={`/livres/${book.slug}`} onClick={onClick} data-testid={`book-discover-${book.slug}`} className="dl-btn" style={{ padding: "0.6rem 1.3rem", fontSize: "0.68rem" }}>
            Découvrir
          </Link>
          {book.price && <span className="text-[#D4B978] text-sm font-medium">{book.price}</span>}
        </div>
      </div>
    </div>
  );
}
